/**
 * NotificationBell pure helpers (A11Y-1).
 */

/** Above this, the badge shows "N+" rather than an exact count. */
export const MAX_BADGE_COUNT = 9;

/** Visible badge text for an unread count (e.g. 12 → "9+"). */
export const buildNotificationBadgeLabel = (unreadCount: number): string =>
  unreadCount > MAX_BADGE_COUNT ? `${MAX_BADGE_COUNT}+` : String(unreadCount);

/**
 * Screen-reader label for the bell, conveying the unread count in words rather
 * than the visual "9+" badge string.
 */
export const buildNotificationBellA11yLabel = (unreadCount: number): string => {
  if (unreadCount <= 0) {
    return 'Notifications, no unread';
  }
  if (unreadCount === 1) {
    return 'Notifications, 1 unread';
  }
  return `Notifications, ${unreadCount} unread`;
};
